/**
 * Game timer. Updates a DOM element with the elapsed time since startMs.
 * Keeps tabular figures stable.
 */

export interface TimerHandle {
  stop(): void;
  setStart(ms: number): void;
}

export function startTimer(target: HTMLElement): TimerHandle {
  let startMs: number | null = null;
  let stopped = false;

  function fmt(ms: number): string {
    const total = Math.floor(ms / 1000);
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  function tick() {
    if (stopped) return;
    if (startMs === null) {
      target.textContent = '00:00';
    } else {
      target.textContent = fmt(performance.now() - startMs);
    }
    requestAnimationFrame(tick);
  }
  tick();

  return {
    stop() {
      stopped = true;
    },
    setStart(ms: number) {
      startMs = ms;
    },
  };
}
